export const MAX_RELATED_ADS = 8;
